export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy/List.vue'),
        name: 'attendance-policy',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy/Add.vue'),
        name: 'attendance-policy-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy-allocation/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy-allocation/List.vue'),
        name: 'attendance-policy-allocation',
        meta: {
            requiresAuth: true
        }
    }
    ,
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy-allocation-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy-allocation/Add.vue'),
        name: 'attendance-policy-allocation-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/holidays/:pageId',
        component: () => import('@/views/page/company/hr-payroll/holidays/List.vue'),
        name: 'holidays',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/holidays-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/holidays/Add.vue'),
        name: 'holidays-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-policy/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-policy/List.vue'),
        name: 'leave-policy',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-policy-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-policy/Add.vue'),
        name: 'leave-policy-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-balance/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-balance/List.vue'),
        name: 'leave-balance',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-balance-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-balance/Add.vue'),
        name: 'leave-balance-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/manual-attendance-hr/:pageId',
        component: () => import('@/views/page/company/hr-payroll/manual-attendance/HrList.vue'),
        name: 'manual-attendance-hr',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-attendance/:pageId',
        component: () => import('@/views/page/company/hr-payroll/my-attendance/List.vue'),
        name: 'my-attendance',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-leave/:pageId',
        component: () => import('@/views/page/company/hr-payroll/my-leave/List.vue'),
        name: 'my-leave',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-report/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-report/List.vue'),
        name: 'attendance-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-report-details/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-report-details/List.vue'),
        name: 'attendance-report-details',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-log-summary/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-report/AttendanceLog.vue'),
        name: 'attendance-log-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-approval/List.vue'),
        name: 'attendance-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-register/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/register/Index.vue'),
        name: 'employee-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-employee/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/Add.vue'),
        name: 'add-employee',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-import/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/employee-import/EmployeeImportList.vue'),
        name: 'employee-import',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-upload-contact/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/employee-import/EmployeeUploadContact.vue'),
        name: 'employee-upload-contact',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-application-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-application-approval/List.vue'),
        name: 'leave-application-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-application/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-application/List.vue'),
        name: 'leave-application',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-application-status/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-application-status/List.vue'),
        name: 'leave-application-status',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-balance-summary/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-balance-summary/List.vue'),
        name: 'leave-balance-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-summary/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-summary/Summary.vue'),
        name: 'attendance-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-monthly-report/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-summary/Report.vue'),
        name: 'attendance-monthly-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-list/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/List.vue'),
        name: 'employee-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-directory/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/employee-directory.vue'),
        name: 'employee-directory',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pay-head/:pageId',
        component: () => import('@/views/page/company/hr-payroll/pay-head/List.vue'),
        name: 'pay-head',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pay-head-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/pay-head/Add.vue'),
        name: 'pay-head-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/salary-structures/:pageId',
        component: () => import('@/views/page/company/hr-payroll/salary-structures/List.vue'),
        name: 'salary-structures',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/salary-grade-scale/:pageId',
        component: () => import('@/views/page/company/hr-payroll/salary-grade-scale/List.vue'),
        name: 'salary-grade-scale',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll-adjustment/:pageId/:payrollMasterId',
        component: () => import('@/views/page/company/hr-payroll/payroll-adjustment/List.vue'),
        name: 'payroll-adjustment',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll-process/:pageId',
        component: () => import('@/views/page/company/hr-payroll/payroll-process/List.vue'),
        name: 'payroll-process',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll-process/:pageId/view/:payrollMasterId',
        component: () => import('@/views/page/company/hr-payroll/payroll-process/Show.vue'),
        name: 'payroll-view',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll/:pageId/statement/:payrollStatementId',
        component: () => import('@/views/page/company/hr-payroll/payroll-process/Statement.vue'),
        name: 'payroll-statement',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll/:pageId/payroll-advice/:payrollStatementId/:paymentModeId',
        component: () => import('@/views/page/company/hr-payroll/payroll-advice/Add.vue'),
        name: 'payroll-advice',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll/:pageId/payroll-advice-list/:payrollStatementId/:paymentModeId',
        component: () => import('@/views/page/company/hr-payroll/payroll-advice/List.vue'),
        name: 'payroll-advice-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll/:pageId/payroll-advice/:payrollMasterId/edit',
        component: () => import('@/views/page/company/hr-payroll/payroll-advice/Edit.vue'),
        name: 'payroll-advice-edit',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-import/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-import/AttendanceImportList.vue'),
        name: 'attendance-import',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/upload-attendance/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-import/UploadAttendance.vue'),
        name: 'upload-attendance',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-requisition/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/List.vue'),
        name: 'job-requisition',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-requisition-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/Add.vue'),
        name: 'job-requisition-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/JobApprovalList.vue'),
        name: 'job-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-posting/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/JobPostingList.vue'),
        name: 'job-posting',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-application-manager/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-application-manager/List.vue'),
        name: 'job-application-manager',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/appointment/:pageId',
        component: () => import('@/views/page/company/hr-payroll/appointment/List.vue'),
        name: 'appointment',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/offer-letter-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/appointment/Add.vue'),
        name: 'offer-letter-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-offboarding-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-off-boarding/OffBoardingApprovalList.vue'),
        name: 'employee-offboarding-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contact-attachment-report/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attachment-report/List.vue'),
        name: 'contact-attachment-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/loan-registers/:pageId',
        component: () => import('@/views/page/company/hr-payroll/loan-registers/List.vue'),
        name: 'loan-registers',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/loan-registers-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/loan-registers/Add.vue'),
        name: 'loan-registers-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payslip-list/:pageId',
        component: () => import('@/views/page/company/hr-payroll/payslip/List.vue'),
        name: 'payslip-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-payslip/:pageId',
        component: () => import('@/views/page/company/hr-payroll/payslip/MyPayslip.vue'),
        name: 'my-payslip',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/letters/:pageId',
        component: () => import('@/views/page/company/hr-payroll/letters/List.vue'),
        name: 'letters',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/letters-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/letters/Add.vue'),
        name: 'letters-add',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/performance-component-setup/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-component/PerformanceComponentSetup.vue'),
        name: 'performance-component-setup',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/performance-appraisal-setup/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-apprisal-setup/List.vue'),
        name: 'performance-appraisal-setup',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/performance-appraisal-setup-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-apprisal-setup/Add.vue'),
        name: 'performance-appraisal-setup-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-performance-appraisal/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-apprisal/List.vue'),
        name: 'my-performance-appraisal',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/performance-appraisal-list/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-apprisal/AllList.vue'),
        name: 'performance-appraisal-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/performance-appraisal-approver/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-apprisal/ApproverList.vue'),
        name: 'performance-appraisal-approver',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/performance-appraisal/:pageId',
        component: () => import('@/views/page/company/hr-payroll/performance-apprisal/PerformanceAppraisalAdd.vue'),
        name: 'performance-appraisal',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/provident-fund-import/:pageId',
        component: () => import('@/views/page/company/hr-payroll/provident-fund/ProvidentFundImportList.vue'),
        name: 'provident-fund-import',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/upload-provident-fund/:pageId',
        component: () => import('@/views/page/company/hr-payroll/provident-fund/UploadProvidentFund.vue'),
        name: 'upload-provident-fund',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pf-statements/:pageId',
        component: () => import('@/views/page/company/hr-payroll/provident-fund/List.vue'),
        name: 'pf-statements',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-pf-statements/:pageId',
        component: () => import('@/views/page/company/hr-payroll/provident-fund/MyProvidentFundList.vue'),
        name: 'my-pf-statements',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll-preference/:pageId',
        component: () => import('@/views/page/company/hr-payroll/payroll-preference/List.vue'),
        name: 'payroll-preference',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-schedule-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-schedule/Add.vue'),
        name: 'attendance-schedule-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-schedule/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-schedule/List.vue'),
        name: 'attendance-schedule',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/doctors-appointment-schedule/:pageId',
        component: () => import('@/views/page/company/hr-payroll/doctor-schedule/Calendar.vue'),
        name: 'doctors-appointment-schedule',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/doctors-appointment-schedule-list/:pageId',
        component: () => import('@/views/page/company/hr-payroll/doctor-schedule/List.vue'),
        name: 'doctors-appointment-schedule-list',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/process-tracker/:pageId',
        component: () => import('@/views/page/company/hr-payroll/process-tracker/List.vue'),
        name: 'process-tracker',
        meta: {
            requiresAuth: true
        }
    },
]